<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'App'
}

// 在 main.js 或 App.vue 的 script 中
window.ResizeObserver = class ResizeObserver extends window.ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      // 使用 requestAnimationFrame 延迟执行回调
      requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>